import { API_BASE_PATH } from '@aibees/shared/constants';
import { urlMock } from '@aibees/shared/utils';

export const WORKSPACE_ROOT_ENDPOINT = `/customer-management/um/workspaces`;
export const PLAN_ROOT_ENDPOINT_GM = '/payment-management/gm/plans'; // deprecated
export const PLAN_ROOT_ENDPOINT_UM =
  '/payment-management/um/customers/:wid/plans';
export const CUSTOMER_ROOT_ENDPOINT = '/payment-management/um/customers';
export const TAX_ID = `/payment-management/um/customers/:customerId/tax-ids`;
export const SUBSCRIPTION_ROOT_ENDPOINT = `${CUSTOMER_ROOT_ENDPOINT}/:customerId/subscriptions`;
export const ENTITLEMENT_ROOT_ENDPOINT = `${CUSTOMER_ROOT_ENDPOINT}/:customerId/products`;
export const SUBSCRIPTION_ROOT_ENDPOINT_WITH_ID = `${CUSTOMER_ROOT_ENDPOINT}/:customerId/subscriptions/:id`;
export const PAYMENT_METHOD_ROOT_ENDPOINT = `${CUSTOMER_ROOT_ENDPOINT}/:customerId/payment-methods`;
export const INVOICE_ROOT_ENDPOINT = `${CUSTOMER_ROOT_ENDPOINT}/:customerId/invoices`;
export const CUSTOMER_TRANSACTIONS_ENDPOINT = `${CUSTOMER_ROOT_ENDPOINT}/:wid/transactions`;
export const TRANSFER_LINK_ROOT_ENDPOINT = `/customer-management/gm/links`;
export const GET_FILE_ROOT_ENDPOINT = `${API_BASE_PATH}/um/workspaces`;
export const LABEL_ROOT_ENDPOINT = `${API_BASE_PATH}/um/workspaces`;
export const GET_SOCKET_TOKEN = `${WORKSPACE_ROOT_ENDPOINT}/:wid/sockets?action=token`;

/* -----------------B2B-Enrichment--------------------- */
export const B2B_ENRICHMENT =
  import.meta.env.VITE_APP_LOCAL_HOST_PATH || 'b2b-enrichment';
export const SUBSCRIPTION_ROOT_ENDPOINT_B2B_ENRICHMENT = `${CUSTOMER_ROOT_ENDPOINT}/subscriptions`;
export const SUBSCRIPTION_ROOT_ENDPOINT_WITH_ID_B2B_ENRICHMENT = `${CUSTOMER_ROOT_ENDPOINT}/subscriptions/:id`;
export const PAYMENT_METHOD_ROOT_ENDPOINT_B2B_ENRICHMENT = urlMock('payment');
export const INVOICE_ROOT_ENDPOINT_B2B_ENRICHMENT = urlMock('invoices');
export const CUSTOMER_ROOT_ENDPOINT_B2B_ENRICHMENT = urlMock('customers');
